import * as React from "react";

import { PersonAccounts24Filled, PersonAccounts24Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const MPAApp = React.lazy(async () => {
    const namedExport = await import(/* webpackChunkName: "MPAApp" */ "./MPAApp");
    return { default: namedExport.MPAApp };
});

export const MPA: TeamAppConfig = {
    title: "MPA",
    regularIcon: PersonAccounts24Regular,
    filledIcon: PersonAccounts24Filled,
    description: "MPA is a simple and intuitive one stop portal for MPA lifecycle management workflows.",
    team: "O365ServiceAuth",
    publicId: "EXCHANGE\\ServiceAuth",
    owner: "o365-service-auth-oc@microsoft.com",
    role: "*",
    tags: [],
    app: MPAApp,
    path: "/mpa"
};
